import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { SavingsAccountStats } from '@/config/chain/types'
import { infoSkyApiUrl } from '@/config/consts'
import { normalizedNumberSchema } from '@/domain/common/validation'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export function skySavingsGeneralStatsQueryOptionsFactory(savingsToken: TokenSymbol) {
  return function skySavingsGeneralStatsQueryOptions() {
    return queryOptions<SavingsAccountStats>({
      queryKey: ['sky-savings-general-stats'],
      queryFn: async () => {
        const response = await fetch(`${infoSkyApiUrl}/api/v1/spark/savings/`)
        if (!response.ok) {
          throw new Error('Error fetching savings general stats')
        }
        const result = await response.json()
        const parsedResult = skySavingsGeneralStatsResponseSchema.parse(result)

        return {
          tvl: parsedResult.tvl,
          users: parsedResult.users,
          liquidity: savingsToken === TokenSymbol('sUSDC') ? parsedResult.liquidityMap.usdc : undefined,
        }
      },
    })
  }
}

const skySavingsGeneralStatsResponseSchema = z
  .object({
    savings_tvl: normalizedNumberSchema,
    number_of_wallets: z.number(),
    liquidity: z.object({
      usdc: normalizedNumberSchema,
    }),
  })
  .transform((o) => ({
    tvl: o.savings_tvl,
    users: o.number_of_wallets,
    liquidityMap: o.liquidity,
  }))
